import TeamKPIPage from './TeamKPIPage'

export default function AllKPIPlansPage() {
  return <TeamKPIPage isHRView />
}
